import React from "react";

import { Filter as GenericFilter } from "~/Driver";
import { DVIRs, DisabledDVIRsSummary } from "~/DVIR";
import * as Layout from "~/Layout";
import * as Preferences from "~/Preferences";

import { Company } from "../../Company";
import { FilterRow } from "../../Filter";
import { shouldShowSelectAFilterPrompt } from "~/DisabledTable";

export function DVIRsSummary() {
  const updateFilters = Preferences.Put.use();
  const [ loadingFilters, userPreferences] = Preferences.Get.useLoading()
  const { company } = Company.use();

  const onFilterByBranch = (
    filteredBranchIds: Company.Branch.Branches.BranchIDs
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey("branchFilter")}`]: filteredBranchIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "DVIR Table",
      "branchFilter"
    );
  };

  const onFilterWorkReportingLocation = (
    filteredWorkReportingLocationIds: GenericFilter.Filter
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey(
        "locationFilter"
      )}`]: filteredWorkReportingLocationIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "DVIR Table",
      "locationFilter"
    );
  };

  const disableMissingLogs = shouldShowSelectAFilterPrompt({companyId: company.id, userPreferences})

  return (
    <Layout.Page.Component all>
      <FilterRow>
        <Company.Branch.Branches.Filter.Component onFilter={onFilterByBranch} />
        <Company.Location.Filter.Component
          onFilter={onFilterWorkReportingLocation}
        />
      </FilterRow>
      <Layout.Section.Component>
          { disableMissingLogs ? 
              (<DisabledDVIRsSummary loading={loadingFilters}/>) 
              : (<DVIRs />)
            }
      </Layout.Section.Component>
    </Layout.Page.Component>
  );
}
